import _ from 'lodash';

import ConversationItem from 'models/conversation_item';
import ConversationItemType from 'models/conversation_item_type';
import { SecureDataRequestStatuses, TransmissionStatuses } from 'models/secure_data_request';
import qconsole from 'scripts/lib/qconsole';

export default class SecureDataRequestHistoryGatewayObserver {
  constructor(context) {
    this.context = context;
  }

  handleUpdateConversationItem({ customerId, conversationItemDto }) {
    if (!this.context.stores.customers.has({ id: customerId })) {
      qconsole.log(
        `Received conversation item [${conversationItemDto.id}] for unloaded customer [${customerId}]. Ignoring.`
      );
      return;
    }
    const customerStores = this.context.stores.customers.storesFor(customerId);
    let conversationItem;
    try {
      conversationItem = ConversationItem.fromJs(conversationItemDto);
    } catch (e) {
      this.context.errorReporter.reportError(e, {
        tags: { customerId, conversationItemId: conversationItemDto.id },
        extra: { conversationItem: conversationItemDto },
        message: 'Ignored conversation item for customer',
      });
      return;
    }
    this._handleActiveSecureDataRequestUpdate({ customerStores, conversationItem });
  }

  _handleActiveSecureDataRequestUpdate({ customerStores, conversationItem }) {
    const activeSecureDataRequestsStore = customerStores.activeSecureDataRequests;
    if (conversationItem.contentType() === ConversationItemType.SECURE_DATA_REQUEST) {
      const requestStatus = _.get(conversationItem, 'content.currentRequestStatus.requestStatus');
      const messageStatus = _.get(conversationItem, 'content.currentRequestStatus.messageStatus');
      if (
        requestStatus !== SecureDataRequestStatuses.REQUESTING ||
        messageStatus.value === TransmissionStatuses.FAILED
      ) {
        activeSecureDataRequestsStore.remove(conversationItem.id);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/customer/secure_data_request_history_gateway_observer.js